import { getTimezoneOffset } from "date-fns-tz";
import { DATE_TIME_LOCALE } from "./constants.js";
function normalizeTimeZone(timeZone = 'local') {
    return 'utc' === timeZone ? 'UTC' : timeZone;
}
function normalizeIANATimeZone(timeZone = 'local') {
    const normalizedTimeZone = normalizeTimeZone(timeZone);
    if (isLocalTimeZone(normalizedTimeZone)) return getLocalIANATimeZone();
    return normalizedTimeZone;
}
function isLocalTimeZone(timeZone) {
    const lowerTimeZone = normalizeTimeZone(timeZone).toLowerCase();
    return 'local' === lowerTimeZone || 'browser' === lowerTimeZone;
}
function getLocalIANATimeZone() {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
}
function getTimeZoneOffsetMs(timeZone) {
    const normalizedTimeZone = normalizeIANATimeZone(timeZone);
    const now = new Date();
    return getTimezoneOffset(normalizedTimeZone, now);
}
function getTimeZoneName(timeZone, { variant = 'short' } = {}) {
    const normalizedTimeZone = normalizeIANATimeZone(timeZone);
    const parts = Intl.DateTimeFormat(DATE_TIME_LOCALE, {
        timeZone: normalizedTimeZone,
        timeZoneName: variant
    }).formatToParts(new Date());
    return parts.find((part)=>'timeZoneName' === part.type)?.value;
}
const TZ_OFFSET_REGEX = /([+-]?)(\d{1,2})(:\d{2})?/;
function getOffsetStrFromTimeZoneName(timeZoneStr) {
    if (!timeZoneStr) return;
    if ('GMT' === timeZoneStr || 'UTC' === timeZoneStr) return 'UTC';
    const offsetMatch = timeZoneStr.match(TZ_OFFSET_REGEX);
    if (offsetMatch && offsetMatch[2]) {
        const [_, signStr, hourStr, minuteStr] = offsetMatch;
        const sign = signStr || '';
        const hour = hourStr.padStart(2, '0');
        const minute = minuteStr || ':00';
        return `${sign}${hour}${minute}`;
    }
    try {
        const now = new Date();
        const timeZoneParts = Intl.DateTimeFormat(DATE_TIME_LOCALE, {
            timeZone: timeZoneStr.replace('GMT', ''),
            timeZoneName: 'longOffset'
        }).formatToParts(now);
        const timeZoneOffset = timeZoneParts.find((part)=>'timeZoneName' === part.type)?.value;
        if ('GMT' === timeZoneOffset) return 'UTC';
        if (timeZoneOffset) return timeZoneOffset.replace('GMT', '');
    } catch (_e) {}
}
export { getLocalIANATimeZone, getOffsetStrFromTimeZoneName, getTimeZoneName, getTimeZoneOffsetMs, isLocalTimeZone, normalizeIANATimeZone, normalizeTimeZone };

//# sourceMappingURL=time-zone-utils.js.map